export class SelfTrainingToolExercise{

    title: string;

    linkToPage: string;

    uniqueId: string;

    done: boolean = false;

    comments: string = "";

}